import {
  IApiResponse,
  IPrintCartonRequest,
  IPrintLORequest,
  IPrintRequest,
  IProductionPlan,
} from "model";
import { BaseApiService } from "./BaseApiService";
import { PREFIX } from "./common";

export const prefix = PREFIX.printing;

const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};
const URL_PRINT = getUrl("print");
const URL_PRINT_CARTON_BARCODE = getUrl("printCartonBarcode");
const URL_PRINT_LO = getUrl("printing-lo");

class ProductionPlanApiService extends BaseApiService {
  public print = (request: IPrintRequest) =>
    this.post<IPrintRequest, IApiResponse<IProductionPlan>>(URL_PRINT, request);
  public printCartonBarcode = (request: IPrintCartonRequest) =>
    this.post<IPrintCartonRequest, IApiResponse<any>>(
      URL_PRINT_CARTON_BARCODE,
      request
    );
  public printLO = (request: IPrintLORequest) =>
    this.post<IPrintLORequest, IApiResponse<any>>(URL_PRINT_LO, request);
}

export default new ProductionPlanApiService();
